// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"9a744696","488":"071462ed"}[chunkId] + ".chunk.js";
};